import { ChecksumAddress, ProtocolInstance } from "@silo/types";
import { isSilo } from "./isSilo";
import {
  createPriceProvidersRepositoryContract,
  createSiloContract,
} from "./createContract";
import { FallbackProvider } from "@ethersproject/providers";

export const isSiloReady = async (
  provider: FallbackProvider,
  protocolInstance: ProtocolInstance,
  siloAddress: ChecksumAddress
): Promise<boolean> => {
  if (!(await isSilo(provider, protocolInstance, siloAddress))) return false;

  let hasWorkingPriceProvider;
  const siloContract = createSiloContract({ siloAddress, provider });
  const priceProviderRepositoryContract =
    createPriceProvidersRepositoryContract({
      protocolInstance,
      provider: provider,
    });
  const siloAssetAddress = await siloContract.siloAsset();
  try {
    hasWorkingPriceProvider =
      await priceProviderRepositoryContract.providersReadyForAsset(
        siloAssetAddress
      );
  } catch (err) {
    console.warn(
      "silo is valid silo, but is not ready, does not have valid price provider:",
      siloAddress
    );
  }
  return !!hasWorkingPriceProvider;
};
